'use client';

import { useEffect, useState } from 'react';
import { isAppEnvironment } from '@/lib/fcm';

/**
 * 启动屏 Logo 动画（v0.8 体验强化包）：
 * App 内首屏启动时，在原生 Splash 收起后播放一层 Logo 放大淡出动画，
 * 平滑过渡到首页，消除「啪一下跳进页面」的割裂感。仅 App 环境生效。
 */
export default function StartupAnimation() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isAppEnvironment()) return;
    setShow(true);
    const t = setTimeout(() => setShow(false), 950);
    return () => clearTimeout(t);
  }, []);

  if (!show) return null;

  return (
    <div className="startup-overlay" aria-hidden="true">
      <img src="/icon.png" alt="" className="startup-logo" />
    </div>
  );
}
